import { useTranslation } from "@localization/useTranslation";
import StatusChip, { statusChipStatus } from "@common/components/statusChip/StatusChip";
import { RiskObservationStatus } from "./RiskObservations.types";

// Deliberately mirrors the contract overview's status colours: a new observation reads like a contract
// draft, a converted one like an approved contract, and an archived one like an archived contract.
const observationStatusColors: Record<RiskObservationStatus, statusChipStatus> = {
    [RiskObservationStatus.New]: "lightgreen",
    [RiskObservationStatus.Converted]: "green",
    [RiskObservationStatus.Archived]: "purple",
};

export interface RiskObservationStatusChipProps {
    status: RiskObservationStatus;
}

function RiskObservationStatusChip(props: RiskObservationStatusChipProps) {
    const { translateRiskObservationStatus } = useTranslation();

    return <StatusChip value={translateRiskObservationStatus(props.status)} status={observationStatusColors[props.status]} />;
}

export default RiskObservationStatusChip;
